module.exports = "//cdn.mxpnl.com/static/asset-cache/82582560d5311ea8c958853a929d1e07/iron/common/assets/images/charts/logarithmic-line.svg";